import { Dispatch } from 'redux';
import { TemplatesController } from '../controllers/TemplatesController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class TemplatesCRUDActionsClass extends CrudActionContainer {
  getTemplatesAction: string;
  getTemplateByIdAction: string;
  setTemplateAction: string;
  updateTemplateAction: string;
  deleteTemplateAction: string;
  resetTemplateAction: string;

  constructor() {
    super('TEMPLATES');
    this.getTemplatesAction = super.makeActionKey('GET');
    this.getTemplateByIdAction = super.makeActionKey('GET_BY_ID');
    this.setTemplateAction = super.makeActionKey('SET');
    this.updateTemplateAction = super.makeActionKey('UPDATE');
    this.deleteTemplateAction = super.makeActionKey('DELETE');
    this.resetTemplateAction = super.makeActionKey('REST');
  }

  getAll(sample: boolean, page: number, perPage: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy());
      try {
        const templates = await TemplatesController.getAll(
          sample,
          page,
          perPage,
        );

        dispatch({
          type: this.getTemplatesAction,
          entities: templates,
        });

        return templates;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  getById(templateId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy());
      try {
        const response = await TemplatesController.getById(templateId);

        dispatch({
          type: this.getTemplateByIdAction,
          entity: response,
        });

        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  create(
    botId: number,
    name: string,
    description: string,
    assetId?: string,
    async?: boolean,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy());
      try {
        const response = await TemplatesController.create(
          botId,
          name,
          description,
          assetId,
          async,
        );

        dispatch({
          type: this.setTemplateAction,
          entity: response,
        });

        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  update(
    templateId: number,
    name: string,
    description: string,
    assetId?: string,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy());
      try {
        const response = await TemplatesController.update(
          templateId,
          name,
          description,
          assetId,
        );

        dispatch({
          type: this.updateTemplateAction,
          entity: response.template,
        });

        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  delete(templateId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy());
      try {
        await TemplatesController.delete(templateId);

        dispatch({
          type: this.deleteTemplateAction,
          entity: { id: templateId },
        });
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }
}

export const TemplatesCRUDActions = new TemplatesCRUDActionsClass();

export const useTemplatesCRUDActions = getActionHookBuilder(
  TemplatesCRUDActions,
  ['getAll', 'delete'],
);
